import { render, staticRenderFns } from "./InventarioDivergenciasList.vue?vue&type=template&id=1b65243f&scoped=true"
import script from "./InventarioDivergenciasList.vue?vue&type=script&lang=js"
export * from "./InventarioDivergenciasList.vue?vue&type=script&lang=js"
import style0 from "./InventarioDivergenciasList.vue?vue&type=style&index=0&id=1b65243f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b65243f",
  null
  
)

export default component.exports